export const DataPermissions = Object.freeze({
  // Patient data operations
  READ_PATIENT: "read:data.patient",
  CREATE_PATIENT: "create:data.patient",
  UPDATE_PATIENT: "update:data.patient",
  DELETE_PATIENT: "delete:data.patient",

  // Image import operations
  IMPORT_MEDICAL_IMAGE: "import:data.medicalimage",
  IMPORT_MORPHOLOGY_IMAGE: "import:data.morphologieimage",

  // Spinesim study operations
  CREATE_SPINESIM_STUDY: "create:data.spinesimstudy",

  // Plan operations
  CREATE_PLAN: "create:data.plan",
  DELETE_PLAN: "delete:data.plan",

  // Delete operations
  DELETE_DIGITAL_TWIN: "delete:data.digitaltwin",
  DELETE_REPORT: "delete:data.report",
  DELETE_INSTANCE: "delete:data.instance",
  DELETE_MORPHOLOGY_IMAGE: "delete:data.morphologieimage",
  DELETE_PAIN_ASSESSMENT: "delete:data.painassessment",
  DELETE_CLINICAL_HISTORY: "delete:data.clinicalhistory",

  // Measure operations
  CREATE_CUSTOM_MEASURE: "create:data.custommeasure",
});

export const AccessPermissions = Object.freeze({
  // Patient related access
  PATIENT_LIST: "access:patient.list",
  PATIENT_DASHBOARD: "access:patient.dashboard",
  PATIENT_PLANNING: "access:patient.planing",

  // Plan related access
  PLAN_VISUALIZE: "access:plan.visualize",
  PLAN_ANALYZE: "access:plan.analyze",
  PLAN_ALIGN: "access:plan.align",

  // Management access
  USER_MANAGEMENT: "access:user.management",
  TENANT_MANAGEMENT: "access:tenant.management",
});
